<template>
  <ChartTitleWrapper :title="title">
    <VueApexCharts type="bar" :height="350" :options="chartOptions" :series="series" />
  </ChartTitleWrapper>
</template>

<script setup>
import { computed } from "vue";
import VueApexCharts from "vue3-apexcharts";

import { getChartOptions } from "@/app/reports/utils/chart";

import ChartTitleWrapper from "@/app/reports/components/charts/ChartTitleWrapper.vue";

const props = defineProps({
  title: String,
  data: Array,
});

const dataWithoutTotal = computed(() => props.data?.filter((row) => row?.tramo !== "Total") || []);
const categories = computed(() => dataWithoutTotal.value?.map((row) => row?.tramo));

const chartOptions = computed(() =>
  getChartOptions({
    xAxis: {
      title: "Horas",
      categories: categories.value,
    },
    yAxis: {
      title: "Número de llamadas",
    },
    chartColors: ["#D9F7BE", "#FFE58F", "#FFA39E", "#91D5FF"],
    legend: {
      show: true,
    },
  })
);

const series = computed(() => [
  {
    name: "Llamadas recibidas",
    data: dataWithoutTotal.value?.map((row) => row?.recibidas),
  },
  {
    name: "Llamadas atendidas",
    data: dataWithoutTotal.value?.map((row) => row?.atendidas),
  },
  {
    name: "Llamadas atendidas del NS",
    data: dataWithoutTotal.value?.map((row) => row?.atendidas_ns),
  },
  {
    name: "Llamadas abandonadas",
    data: dataWithoutTotal.value?.map((row) => row?.abandonadas),
  },
]);
</script>

<style lang="sass" scoped>
h3
  font-size: 16px
  font-weight: 600
  margin: 35px 0 12px 0
  text-align: center
</style>
